import React from "react";

import { SentinelInfoSection } from "./sentinel-info-section";
import { LeadershipMonitorSchedule, MonitorSchedules } from "src/web/components/MonitorSchedules";
import { DependencyCoverageSection } from "src/web/components/DependencyCoverage";
import { CrCriteriaSection } from "src/web/components/CrCriteria";

export const SentinelDefaultInfoSection = () => (
    <SentinelInfoSection header="Dependency Sentinel">
        <div>
            <p>
                Dependency Sentinel is a platform that automatically generates code reviews for
                trivially updatable dependencies. It periodically scans software packages and gathers a list of
                dependencies, new releases, and updated guidance, producing code reviews where applicable. The
                package owners are expected to review and merge the code reviews produced, as well
                as conduct end to end integration testing as per their regular deployment process.
            </p>
            <DependencyCoverageSection />
            <CrCriteriaSection />
            <h4>When data refreshes</h4>
            <p>
                Nothing on this site updates the moment you load it. Each part of the data comes
                from a scheduled run, so a change you expect to see appears after that run
                finishes:
            </p>
            <MonitorSchedules />
            <LeadershipMonitorSchedule />
            <h4>Reading a timestamp</h4>
            <p>
                Where a page shows an &quot;as of&quot; date, that is when the run that produced the
                data finished. If a dependency was
                upgraded after that time, it will still show the older version until the next
                run.
            </p>
        </div>
    </SentinelInfoSection>
);
